import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/firebase';
import './Auth.css';

function Verify() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      // Get userId from the authenticated Firebase user via backend /me endpoint
      const idToken = await auth?.currentUser?.getIdToken();
      if (!idToken) {
        setError('Please sign in first.');
        return;
      }

      const API_BASE = (import.meta as any).env?.VITE_API_BASE || '';
      const meRes = await fetch(`${API_BASE}/auth/me`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${idToken}` },
      });
      if (!meRes.ok) {
        setError('Unable to verify your identity. Please sign in again.');
        return;
      }
      const meData = await meRes.json();
      const userId = meData?.data?.id;
      if (!userId) {
        setError('User not found. Please sign in first.');
        return;
      }

      const res = await fetch(`${API_BASE}/verify/code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, code }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data?.error || 'Verification failed');
        return;
      }

      setSuccess('Your phone number is verified. Redirecting...');
      setTimeout(() => navigate('/settings'), 1500);
    } catch (err) {
      console.error('Verification error', err);
      setError('Verification failed');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1>Verify Phone</h1>
          <p className="auth-subtitle">Enter the 6-digit code we sent to your phone.</p>

          {error && <div className="auth-error">{error}</div>}
          {success && <div className="auth-success">{success}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="code">Verification Code</label>
              <input id="code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456" maxLength={6} />
            </div>

            <button type="submit" className="btn btn-primary btn-full">Verify</button>
          </form>

          <p className="auth-footer">Didn&apos;t receive a text? Go back to <a href="/signup">signup</a> and request a new code.</p>
        </div>
      </div>
    </div>
  );
}

export default Verify;
